// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableReviews_Component__1WVMH","Table_Title":"DataTableReviews_Table_Title__3BOO3","Table_Address":"DataTableReviews_Table_Address__3oycz"};